export default __webpack_public_path__ + "static/media/gradient-border.4c49fcf1.svg";